export var PRACTICE_ASSIGNMENT_REPOSITORY = 'PRACTICE_ASSIGNMENT_REPOSITORY';